// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"991305de","78":"9b84cc27","188":"c89d6898","359":"2509519b","570":"879036bc","592":"e1a5a30d","938":"f2c2f6b0"}[chunkId] + ".chunk.js";
};